import { z } from "zod";

export const selectPlanSchema = z
  .object({
    customerType: z.enum([
      "RES",
      "MOBI-POSTPAID",
      "FREEDOM",
      "MOBI-PREPAID",
      "TOURIST",
    ]),
    plan: z.object({
      id: z.string().min(1, { message: "Plan is required" }),
      name: z.string(),
      price: z.string(),
    }),
    automaticNumberSelection: z.boolean().optional(),
    sim: z
      .object({
        id: z.string().optional(),
        name: z.string().optional(),
        price: z.number().optional(),
      })
      .optional(),
    device: z
      .object({
        id: z.string().optional(),
        sku: z.string().optional(),
        name: z.string().optional(),
        color: z.string().optional(),
        price: z.number().optional(),
      })
      .optional(),
    addon: z
      .object({
        id: z.string().optional(),
        name: z.string().optional(),
        price: z.number().optional(),
      })
      .optional(),
  })
  .superRefine((data, context) => {
    if (data.customerType !== "RES" && !data.sim?.id) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please choose a SIM option",
        path: ["sim.id"],
      });
    }
  });
